export enum MessageInfoType {
    general = 0,
    information = 1,
    warning = 2,
    error = 3,
    confirm = 4
}